import { ICommit } from "@/apps/admin-console/shared-models/ICommit";
import IAdminState from "@/types/admin";

const actions = {
  setAdminState: ({ commit }: ICommit, payload: IAdminState): void => {
    commit("SET_ADMIN_STATE", payload);
  },
  setAdminJwt: ({ commit }: ICommit, payload: string): void => {
    commit("SET_ADMIN_JWT", payload);
  },
};

export default actions;
